// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2355":"4193f4da","3391":"1158f258","5665":"1158f258","6276":"5713cfb7","8494":"5713cfb7","8581":"5713cfb7"}[chunkId] + ".chunk.css";
};